import { Layout } from "antd"
import React from "react"
import { Route, Switch } from "react-router-dom"
import "./App.scss"
import AvatarDropDown from "./components/AvatarDropDown/AvatarDropDown"
import Routes from "./components/Routing/routes"
import "./scss/base.scss"
import "./components/Notification/Notifications"
import { ErrorBoundary } from "./components/ErrorBoundary"

const { Header, Content } = Layout

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <Layout>
          <Header>
            <div>
              <AvatarDropDown />
            </div>
          </Header>

          <Content className="">
            <Switch>
              <Route component={Routes} />
            </Switch>
          </Content>
        </Layout>
      </ErrorBoundary>
    </div>
  )
}

export default App
